module.exports = __webpack_public_path__ + "static/media/Corded_ware_germany_text_01.9c9b6e99.png";